import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class OrganizeModeService {
	private readonly isOrganizeModeActiveState = signal(false);
	public readonly isOrganizeModeActive = this.isOrganizeModeActiveState.asReadonly();

	public enterOrganizeMode(): void {
		this.isOrganizeModeActiveState.set(true);
	}

	public leaveOrganizeMode(): void {
		this.isOrganizeModeActiveState.set(false);
	}
}
